import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { environment } from 'src/environments/environment';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';

@Injectable({
  providedIn: 'root'
})
export class SedeService {
  // private configUrl = 'api/sedes';
  private configUrl = [environment.apiGatewayUrl, 'sedes'].join('/');

  constructor(private http: HttpClient) { }

  getListFiltered(
    model: IFilterSedeModel
    ) : Observable<SearchResultModel<ISedeModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if (model.sede !== '') {
      queryParams.push(`sede=${model.sede}`);
    }
    
    if(model.companias.length > 0){
      queryParams.push(`companias=${model.companias.join(',')}`); 
    }

    return this.http.get<SearchResultModel<ISedeModel[]>>(
      `${this.configUrl}/filtrar?${queryParams.join('&')}`
    );
  }

  getList(
    model: IFilterSedeModel
    ) : Observable<ISedeModel[]> {
    let queryParams: string[] = new Array<string>();

    if(model.companias.length > 0){
      queryParams.push(`companias=${model.companias.join(',')}`); 
    }

    return this.http.get<ISedeModel[]>(
      `${this.configUrl}/?${queryParams.join('&')}`
    );
  }

  getAllList(
    model: IFilterSedeModel
    ) : Observable<ISedeModel[]> {
    let queryParams: string[] = new Array<string>();

    if(model.companias.length > 0){
      queryParams.push(`companias=${model.companias.join(',')}`); 
    }

    return this.http.get<ISedeModel[]>(
      `${this.configUrl}/all?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<ISedeModel> {
    return this.http.get<ISedeModel>(`${this.configUrl}/${id}`);
  }

  submit(model: ISedeModel) {
    return this.http.post<ISedeModel>(`${this.configUrl}`, model);
  }

  update(model: ISedeModel) {
    return this.http.put<ISedeModel>(
      `${this.configUrl}/${model.idSede}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<ISedeModel>(`${this.configUrl}/${id}`);
  }
}
